module.exports = __webpack_public_path__ + "components/resort-finder/static/icon__cards-f05d5f60257c6cf4577ddbaab4b5e145.svg";